import { connect } from 'react-redux'
import { useEffect, useState } from 'react'
import freqTable from 'Dummy/freqTable'
import Feather from '@sysunite/react-feather'
import { Row, Col, Slider, Select, Tooltip, Button, InputNumber, Switch } from 'antd'
import './GraphSynth.scss'
import { getTypeForNode } from 'Services/WeaverUtils'
import { setBPM } from 'Actions/graph'
import { Sequencer, Scheduler } from 'Synth'
import * as Parts from 'Synth/parts'

GraphSynth = ({ graphData: { nodes, edges }, BPM, setBPM }) ->

  [active, setActive] = useState(false)
  [tooltipVisible, setTooltipVisible] = useState(false)
  [playMusic, setPlayMusic] = useState(true)

  classNames = ['graph-synth']
  TYPES = _.keys(Parts)

  if active
    classNames.push('is-open')

  parseSeq = (seq) ->
    JSON.parse(seq).map((val) -> freqTable["#{val}"])

  initSynthEnv = ->
    window.wvrAudioContext = new (window.AudioContext or window.webkitAudioContext)
    compressorOpts = {
      attack: 0
      release: 0.25
      knee: 15
      ratio: 10
      threshold: -50
    }
    window.masterLimiter = new DynamicsCompressorNode(window.wvrAudioContext, compressorOpts)
    window.masterLimiter.connect(window.wvrAudioContext.destination)
    window.synthParts = {}
    window.scheduler = new Scheduler(window.wvrAudioContext, { bpm: BPM })

  useEffect(->
    initSynthEnv()
    ->
      window.wvrAudioContext.close()
      window.synthParts = {}
      window.scheduler.removeAllListeners()
  , [])

  useEffect(->
    audioContext = window.wvrAudioContext
    ( ->
      if audioContext? and playMusic
        await audioContext.resume()
      else
        await audioContext.suspend()
    )()
    undefined
  , [playMusic])

  createByType = {
    'Analyser': (audioContext, node) ->
      analyser = window.synthParts[node.id()] or audioContext.createAnalyser()
      analyser.fftSize = node.get('fftSize')
      freqDomain = new Uint8Array(analyser.frequencyBinCount)
      window.testAnalyser = ->
        analyser.getByteFrequencyData(freqDomain)
      { [node.id()]: analyser }
    'Delay': (audioContext, node) ->
      delayNode = window.synthParts[node.id()] or audioContext.createDelay(node.get('delayTime'))
      { [node.id()]: delayNode }
    'Sequencer': (audioContext, node) ->
      sequencer = window.synthParts[node.id()] or new Parts['Sequencer'](audioContext, {
        scheduler: window.scheduler
        sequence: parseSeq(node.get('noteSequence') or '[]')
      })

      { [node.id()]: sequencer }
    'Oscillator': (audioContext, node) ->
      oscillator = window.synthParts[node.id()] or new Parts['Oscillator'](audioContext, { type: node.get('waveType') })
      { [node.id()]: oscillator }
    'Compressor': (audioContext, node) ->
      compressor = window.synthParts[node.id()] or audioContext.createDynamicsCompressor()
      compressor.threshold.value = node.get('threshold')
      compressor.knee.value = node.get('knee')
      compressor.ratio.value = node.get('ratio')
      compressor.attack.value = node.get('attack')
      compressor.release.value = node.get('release')
      { [node.id()]: compressor }
    'Filter': (audioContext, node) ->
      filterNode = window.synthParts[node.id()] or audioContext.createBiquadFilter()
      filterNode.type = node.get('filterType')
      filterNode.frequency.value = node.get('freqVal')
      filterNode.gain.value = node.get('freqGain')
      { [node.id()]: filterNode }
    'Gain': (audioContext, node) ->
      value = node.get('gain')
      gain = window.synthParts[node.id()] or new Parts['Gain'](audioContext, { value })
      gain.setValue(value) if gain.getValue() isnt value
      { [node.id()]: gain }
    'StereoPan': (audioContext, node) ->
      value = node.get('pan')
      stereoPanner = window.synthParts[node.id()] or new Parts['StereoPan'](audioContext, { value })
      stereoPanner.setValue(value) if stereoPanner.getValue() isnt value
      { [node.id()]: stereoPanner }
    'Panner': (audioContext, node) ->
      panner = window.synthParts[node.id()] or audioContext.createPanner()
      panner.panningModel = node.get('panningModel')
      panner.distanceModel = node.get('distanceModel')
      panner.refDistance = node.get('refDistance')
      panner.maxDistance = node.get('maxDistance')
      panner.rolloffFactor = node.get('rolloffFactor')
      panner.coneInnerAngle = node.get('coneInnerAngle')
      panner.coneOuterAngle = node.get('coneOuterAngle')
      panner.coneOuterGain = node.get('coneOuterGain')
      panner.setOrientation(node.get('orientationX'), node.get('orientationY'), node.get('orientationZ'))
      { [node.id()]: panner }
    'AudioContext': (audioContext, node) ->
      { [node.id()]: 'AudioContext' }
    'Compressor': (audioContext, node) ->
      compressorNode = window.synthParts[node.id()] or audioContext.createDynamicsCompressor()
      compressorNode.threshold.value = node.get('threshold')
      compressorNode.knee.value = node.get('knee')
      compressorNode.ratio.value = node.get('ratio')
      compressorNode.attack.value = node.get('attack')
      compressorNode.release.value = node.get('release')
      { [node.id()]: compressorNode }
    'Analyser': (audioContext, node) ->
      analyserNode = window.synthParts[node.id()] or audioContext.createAnalyser()
      analyserNode.fftSize = node.get('fftSize')
      bufferLength = analyserNode.frequencyBinCount
      dataArray = new Uint8Array(bufferLength)
      { [node.id()]: analyserNode }
  }

  useEffect(->
    (->
      try
        audioContext = window.wvrAudioContext
        masterLimiter = window.masterLimiter
        synthParts = window.synthParts
        window.scheduler.setBPM(BPM)

        if audioContext?

          synthNodes = _.filter(nodes, (node) ->
            node.group in TYPES
          )

          _.map(_.difference(_.keys(synthParts), _.map(synthNodes, 'id')), (removedPart) ->
            if synthParts[removedPart]?.disconnect? then synthParts[removedPart].disconnect()
            delete window.synthParts[removedPart]
          )

          result = await new Weaver.Query()
            .restrict(_.map(synthNodes, 'id'))
            .selectOut('send')
            .hasNoRelationIn('type')
            .find()

          _.map(result, (part) ->

            sends = part.relation('send').all()
            createdSendParts = _.reduce(sends, (acc, send) ->
              partType = getTypeForNode(send)
              { acc..., createByType[partType](audioContext, send)... }
            , {})
            window.synthParts = { window.synthParts..., createdSendParts... }
            partType = getTypeForNode(part)
            createdPart = createByType[partType](audioContext, part)

            window.synthParts = {
              window.synthParts...
              createdPart...
            }

            if not _.isEmpty(sends)
              _.map(createdSendParts, (createdSendPart) ->
                if createdPart[part.id()].connect?
                  if createdSendPart is 'AudioContext'
                    destination = createdPart[part.id()].connect(masterLimiter)
                  else
                    destination = createdPart[part.id()].connect(createdSendPart)

                  createdPart[part.id()].destination = destination
              )

            else
              if synthPart = window.synthParts[part.id()]
                if synthPart.disconnect?
                  synthPart.disconnect()
                if synthPart.active?
                  synthPart.active = false
          )
      catch e
        console.log e
    )()
    undefined
  , [nodes, edges, BPM])

  <div className={classNames.join(' ')}>
    <Row gutter={8}>
      <Col>
        <Tooltip
          placement="bottomLeft"
          trigger="hover"
          mouseEnterDelay={1}
          visible={not active and tooltipVisible}
          title="Play that funky music white boy"
          onVisibleChange={setTooltipVisible}>
          <Button
            className={active and playMusic and 'active'}
            type="link"
            onClick={->
              setActive(not active)
            }
            icon={<Feather size="1.5em" type="speaker" />}/>
        </Tooltip>
      </Col>
      {
        if active
          <Row gutter={8} align="middle">
            <Col>
              <InputNumber
                defaultValue={BPM}
                onPressEnter={
                  (e) -> setBPM(e.target.value)
                }
              />
            </Col>
            <Col>
              <Switch
                checkedChildren="Stop"
                unCheckedChildren="Play"
                defaultChecked={playMusic}
                onChange={(checked) ->
                  setPlayMusic(checked)
                }/>
            </Col>
          </Row>
      }
    </Row>
  </div>

export default connect(
  ({ graph: { graphData, BPM }}) ->
    { graphData, BPM }
  , { setBPM }
)(GraphSynth)
